import dayjs from "dayjs";

interface EventBadgeProps {
  date: string;
}

export const EventBadge = (props: EventBadgeProps) => {
  const now = new Date();
  const nowDate = `${now.getFullYear()}-${now.getMonth() + 1}-${now.getDate()}`;
  const daysToGo = dayjs(props.date).diff(nowDate, "days");

  let badgeContent: string;
  const badgeClass: string[] = ["badge-event"];

  switch (true) {
    case daysToGo < 0:
      badgeContent = "Past event";
      break;
    case daysToGo <= 7:
      badgeContent = "Within 7 days";
      badgeClass.push("badge-tertiary");
      break;
    case daysToGo <= 30:
      badgeContent = "Within a month";
      badgeClass.push("badge-primary");
      break;
    default:
      badgeContent = "Over four weeks away";
      badgeClass.push("badge-danger");
      break;
  }

  if (badgeContent === "Past event") {
    return null;
  }

  return <span className={badgeClass.join(" ")}>{badgeContent}</span>;
};
